import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import Card from "shared/components/UIElements/Card";
import Button from "shared/components/FormElements/Button";
import { useHttpClient } from "shared/hooks/http-hook";
import { AuthContext } from "shared/context/auth-context";
import { trackSuiteEvent } from "shared/util/track";
import { createAndLoginDemoAccount } from "features/start/demo-session";

const DemoLoginCard = () => {
  const auth = useContext(AuthContext);
  const { t } = useTranslation();
  const { sendRequest } = useHttpClient();
  const [isDemoLoading, setIsDemoLoading] = useState(false);
  const [error, setError] = useState(null);

  const loginWithDemoHandler = async () => {
    trackSuiteEvent("Signup — Start Demo (Demo Card)", "button_click");
    setError(null);
    setIsDemoLoading(true);

    try {
      await createAndLoginDemoAccount({
        sendRequest,
        login: auth.login,
      });
    } catch (err) {
      setError(err?.message || t("anErrorOccurred"));
    } finally {
      setIsDemoLoading(false);
    }
  };

  return (
    <Card className="demo-authentication">
      <h2 style={{ marginTop: "5px" }}>{t("auth.tryLiveDemoInstantly")}</h2>
      <hr style={{ width: "100%", margin: "0 auto", marginBottom: "15px" }} />
      <ul className="demo-features-list">
        <li>{t("auth.demoFeature1")}</li>
        <li>{t("auth.demoFeature2")}</li>
        <li>{t("auth.demoFeature3")}</li>
      </ul>
      <Button type="button" onClick={loginWithDemoHandler} isLoading={isDemoLoading}>
        {t("auth.startDemoNow")}
      </Button>
      <p className="demo-no-signup">{t("auth.noSignupRequired")}</p>
      {error && <p className="demo-error">{error}</p>}
    </Card>
  );
};

export default DemoLoginCard;
